/**
 * Navigates to a url with a hard refresh.
 * Do not use this for React routes. Consider adding your route to `ANGULAR_EXACT_PATH_MATCHES`
 * and manage all path changes via `react-router` path changes.
 * `ANGULAR_EXACT_PATH_MATCHES` will automatically reload the page when visiting Angular paths
 * and as you convert to React, you can simply remove your path from that, reducing other refactoring.
 *
 * @param url - The url to navigate to.
 */
export function navigateAndRefreshBrowser(url: string): void {
  window.location.assign(url);
}

/**
 * Open url in a new tab, while protecting from security risks related to `referrer`
 *
 * See https://getcolor.atlassian.net/browse/ENG-584
 * https://www.jitbit.com/alexblog/256-targetblank---the-most-underestimated-vulnerability-ever/
 * https://mathiasbynens.github.io/rel-noopener
 * See lint rule react/jsx-no-target-blank
 */
export function openNewBrowserTab(url: string): void {
  window.open(url, '_blank', 'noopener,noreferrer');
}

/**
 * Scroll an element into view. Accounts for legacy browsers that do not support
 * `scrollIntoView`.
 *
 * @param element The element to scroll into view.
 * @param options The options to pass to `scrollIntoView` if it is called.
 */
export function scrollIntoView(element: HTMLElement, options?: ScrollIntoViewOptions): void {
  const doesScrollIntoViewExist = Boolean(element.scrollIntoView);
  /**
   * Some legacy browsers do not support `scrollIntoView`.
   * Base `focus` options on browser support.
   */
  element.focus?.({ preventScroll: doesScrollIntoViewExist });
  if (doesScrollIntoViewExist) {
    element.scrollIntoView(options);
  }
}
